module.exports = __webpack_public_path__ + "img/laptop-construction-machines-DE.1d22a261.png";